<template>
	<div class="aside-content">
		<img src="../assets/images/center/ico-logo.png" alt="" class="logo">
		<div class="topmenu pointer" @click="goCX" :class="[curMenu == 3 ? 'active' : '']">
			<div class="topmenu-img">
				<img src="../assets/images/center/ico-changxue-selected.png" alt="" class="selected" />
				<img src="../assets/images/center/ico-changxue-default.png" alt="" class="no-selected" />
			</div>
			<div class='font-14 topmenu-name'>{{ $t("newCenter.cx") }}</div>
		</div>
		<div class="topmenu pointer" @click="goStudyCenter" :class="[curMenu == 1 ? 'active' : '']">
			<div class="topmenu-img">
				<img src="../assets/images/center/ico-shangke-selected.png" alt="" class="selected" />
				<img src="../assets/images/center/ico-shangke-default.png" alt="" class="no-selected" />
			</div>
			<div class='font-14 topmenu-name'>{{ $t("menu.studycenter") }}</div>
		</div>
		<div class="btn_bottom">
			<div class="pointer scobj bottList" @mouseleave="closeView" @mouseenter="openView">
				<img src="../assets/images/center/ico-download-default.png" alt="" class="bottom-no-select" />
				<img src="../assets/images/center/ico-download-hover.png" alt="" class="bottom-select" />
				<div class="font-12 bottom-text">{{ $t("newCenter.xz") }}</div>
			</div>
			<div class="share-rqcode" v-if="shareShow">
				<div class="rqcode-item font-18">
					{{ $t("newCenter.xzts") }}
				</div>
				<div class="flex flex-between" style="width: 100%;">
					<div class="share-qrcode-img">
						<img src="../assets/images/login/downloadApp.png" alt="">
					</div>
					<div class="rqcode-left">
						<div class="font-14 " style="margin: 0.4rem 0 0.8rem 0;">安卓 For Student</div>
						<div class="font-14">苹果 For Student</div>
					</div>
				</div>
			</div>
			<div class="pointer scobj bottList" @mouseleave="closeService" @mouseenter="openService">
				<img src="../assets/images/center/ico-guanzhu-default.png" alt="" class="bottom-no-select" />
				<img src="../assets/images/center/ico-guanzhu-hover.png" alt="" class="bottom-select" />
				<div class="font-12 bottom-text">{{ $t("newCenter.Follow") }}</div>
			</div>
			<div class="share-rqcode" v-if="serviceShow" style="top: -1.2rem;">
				<div class="rqcode-item font-18">{{ $t("newCenter.gzts") }}</div>
				<div class="share-qrcode-img" style="margin: 0 auto;">
					<img src="../assets/images/login/publicWX_de.jpg" alt="">
				</div>
			</div>

			<div class="pointer bottList" @click="switchLang" v-if="!threeFlowers">
				<img src="../assets/images/center/ico-set-default.png" alt="" class="bottom-no-select" />
				<img src="../assets/images/center/ico-set-hover.png" alt="" class="bottom-select" />
				<div class="font-12 bottom-text">{{ $t("newCenter.Setting") }}</div>
			</div>
			<div class="pointer bottList" @click="exitLogin">
				<img src="../assets/images/center/ico-logout-default.png" alt="" class="bottom-no-select" />
				<img src="../assets/images/center/ico-logout-hover.png" alt="" class="bottom-select" />
				<div class="font-12 bottom-text">{{ $t("newCenter.Exit") }}</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		mapGetters,
		mapMutations
	} from "vuex";
	export default {
		data() {
			return {
				serviceShow: false,
				shareShow: false,
				userId: localStorage.getItem("userId"),
				userInfo: {},
				certificateNum: 0,
				notCertificateExamObj: {
					list: [],
					totalNum: 0
				},
				threeFlowers: false
			};
		},
		created() {
			// this.initPage();
		},
		mounted() {
			let threeFlowers = localStorage.getItem('threeFlowers') || localStorage.getItem('crmPage') || null
			this.threeFlowers = threeFlowers
		},
		watch: {
			initPageFlag(val) {
				if (val) {
					this.initPage()
					this.CHANGEINITPAGE(false);
				}
			}
		},
		computed: {
			curMenu() {
				return this.$store.state.common.curMenu;
			},
			...mapGetters("common", ["initPageFlag"])
		},
		methods: {
			switchLang() {
				if (this.userId) {
					this.$store.dispatch("common/changeLanguageDialogVisible", true);
				} else {
					if (this.$route.path == '/learning/index') {
						localStorage.setItem('locationReash', 1)

					} else {
						localStorage.setItem('locationReash', 1)
						this.$router.replace({
							path: "/learning/index"
						});
					}

				}

			},
			exitLogin() {
				if (this.userId) {
					this.$confirm(
							`${this.$t("newCenter.logoutConfirm")}`,
							`${this.$t("newCenter.tips")}`, {
								confirmButtonText: `${this.$t("newCenter.confirm")}`,
								cancelButtonText: `${this.$t("common.cancel")}`,
								cancelButtonClass: "cancel",
								confirmButtonClass: "confirm",
								customClass: "webstu-msgbox",
								dangerouslyUseHTMLString: true
							}
						)
						.then(() => {
							let threeFlowers = localStorage.getItem('threeFlowers') ||  null;
							let crmPage = localStorage.getItem('crmPage') || null;
							localStorage.clear();
							sessionStorage.clear();
							if (threeFlowers) {
								localStorage.setItem('threeFlowers', threeFlowers);
							}
							if (crmPage) {
								localStorage.setItem('crmPage', crmPage);
							}
							window.location.href = `${
					  this.WITSBOX_ENV_PARAM.loginPage
					}#/learning/index`;

						})
						.catch(() => {
							// on cancel
						});

				} else {
					if (this.$route.path == '/learning/index') {
						localStorage.setItem('locationReash', 1)

					} else {
						localStorage.setItem('locationReash', 1)
						this.$router.replace({
							path: "/learning/index"
						});
					}

				}

			},
			goStudyCenter() {
				if (this.userId) {
					this.$router.push({
						path: "/study/center"
					});
				} else {
					if (this.$route.path == '/learning/index') {
						localStorage.setItem('locationReash', 1)

					} else {
						localStorage.setItem('locationReash', 1)
						this.$router.replace({
							path: "/learning/index"
						});
					}

				}
			},
			goCX() {
				this.$router.push({
					path: `/learning/index`
				});
			},
			openService() {
				this.serviceShow = true
			},
			closeService() {
				this.serviceShow = false
			},

			openView() {
				this.shareShow = true
			},
			closeView() {
				this.shareShow = false
			},
			toLogin() {
				this.$emit('loginDialog', true)
				// this.$router.replace({ path: "/user/login" });
			},
			getNotCertificateExam() {
				if (!this.userId) return
				let url =
					`${this.WITSBOX_ENV_PARAM.baseUrl}/project/notCertificateExam/${this.userId}?tem=${new Date().getTime()}`
				this.request.get(url).then(res => {
					this.notCertificateExamObj = res.dataModel || {
						list: [],
						totalNum: 0
					}
				})
			},
			clickMyAchievement(type) {
				if (type == 'certificate') {
					this.$router.push({
						path: '/certificate/myCertificate'
					})
				}
			},
			getCertificateNum() {

				if (this.userId) {
					this.request.get(
							`${this.WITSBOX_ENV_PARAM.baseUrl}/project/certificateNum/${this.userId}?tem=${new Date().getTime()}`)
						.then((res) => {
							this.certificateNum = res && res.dataModel || 0
						});
				}

			},

			initPage() {
				if (!this.userId) return
				this.request
					.get(
						`${this.WITSBOX_ENV_PARAM.baseUrl}/user/userAccount/${this.userId}?tem=${new Date().getTime()}`
					)
					.then(res => {
						if (res.success) {
							this.userInfo = res.dataModel.object;
							this.userInfo.headUrl = res.dataModel.url;
						}
					});
			},
			...mapMutations("common", ["CHANGEINITPAGE"])
		}
	};
</script>
<style scoped lang="scss">
	.scobj {
		position: relative;
	}

	.btn_bottom {
		width: 4rem;
		position: absolute;
		bottom: 0.4rem;
		text-align: center;
		color: #999999;

		.bottList {
			margin-bottom: 0.6rem;
			width: 4rem;

			.bottom-no-select {
				width: 1.6rem;
				height: 1.6rem;
				margin-bottom: 0.16rem;
			}

			.bottom-select {
				width: 1.6rem;
				height: 1.6rem;
				margin-bottom: 0.16rem;
				display: none;
			}

			.bottom-text {
				height: 0.52rem;
				line-height: 0.52rem;
				font-family: PingFang SC;
				font-weight: 500;
			}

			&:hover {
				color: #FFFFFF;

				.bottom-no-select {

					display: none;
				}

				.bottom-select {
					display: inline-block;
				}
			}
		}
	}

	.share-rqcode {
		cursor: auto;
		position: absolute;
		top: -3.6rem;
		left: 4rem;
		z-index: 9;
		width: 14.4rem;
		height: 9.6rem;
		padding: 0.88rem 1.2rem;
		box-sizing: border-box;
		border-radius: 0.8rem;
		background-color: #fff;


		.rqcode-item {
			margin-bottom: 1.2rem;
			font-family: PingFang SC;
			font-weight: bold;
			height: 0.8rem;
			line-height: 0.8rem;
			color: #333333;
		}



		.rqcode-text {
			color: #333333;
			font-size: 0.4rem;
			margin: 0.4rem 0 1.2rem;
		}

		.share-qrcode-img {
			width: 4.8rem;
			height: 4.8rem;



			img {
				width: 4.8rem;
				height: 4.8rem;
			}
		}

		.rqcode-left {
			div {
				width: 6.4rem;
				height: 1.6rem;
				line-height: 1.6rem;
				background: #F0F2F5;
				font-family: PingFang SC;
				font-weight: 500;
				color: #333333;

			}
		}
	}

	.todo_acquired {
		font-size: 12px;
		color: #fff;
		background: #fe8f7b;
		border-radius: 10px;
		padding: 2px 3px;
		width: 65px;
		text-align: center;
	}

	.aside-content {
		background: #17274AFF;
		width: 4rem;
		// overflow: hidden;
		position: relative;

		.logo {
			display: block;
			width: 3.2rem;
			height: 3.2rem;
			margin: 0 auto;
			margin-bottom: 2.4rem;
			margin-top: 0.56rem;
		}

		.topmenu {
			text-align: center;
			width: 3.2rem;
			margin: 0 auto;
			border-radius: 0.6rem;
			height: 3.2rem;
			margin-bottom: 0.4rem;
			background: rgba(255, 255, 255, 0.1);

			color: #DDDDDD;

			img {
				margin-top: 0.3rem;
				width: 1.6rem;
				height: 1.6rem;
				margin-bottom: 0.2rem;

				&.selected {
					display: none;
				}

				&.no-selected {
					display: block;
				}
			}

			&.active {
				color: #FFFFFF;
				background: #1F85FC;

				.selected {
					display: block;
				}

				.no-selected {
					display: none;
				}
			}

			&:hover {
				color: #FFFFFF;

				.selected {
					display: block;
				}

				.no-selected {
					display: none;
				}
			}

			.topmenu-name {
				height: 0.6rem;
				line-height: 0.6rem;
			}

			.topmenu-img {
				width: 100%;
				display: flex;
				justify-content: center;
			}

		}

		.studycenter {}

	}

	.stuinfo {
		margin: 25px 20px 0;
		height: 42px;

		.face {
			float: left;
			width: 38px;
			height: 38px;
			border: 2px solid #304fad;
			border-radius: 50%;
			margin-right: 15px;
			display: block;
			overflow: hidden;

			img {
				display: block;
				width: 100%;
				height: 100%;
			}
		}

		.name {
			float: left;
			font-size: 16px;
			font-weight: bold;
			line-height: 42px;
			display: block;
			max-width: 107px;
		}
	}

	.iconmobile,
	.iconemail {
		width: 30px;
		height: 30px;
		display: inline-block;
		margin-right: 15px;
		vertical-align: middle;
	}

	.iconmobile {
		background: url(../assets/images/icons/mobile.png) no-repeat;
	}

	.iconemail {
		background: url(../assets/images/icons/email.png) no-repeat;
	}

	.infolist {
		padding: 0 20px;
		list-style: none;

		li {
			border-bottom: 1px solid #ebeff9;
			font-size: 0;

			&.base {
				height: 45px;

				.con {
					line-height: 44px;
					font-size: 14px;
					display: inline-block;
					vertical-align: middle;
					max-width: 115px;
				}
			}

			&.certificate {
				border-bottom: none;
				padding: 15px 0;
				position: relative;

				.words {
					color: #333;
					font-size: 15px;
					display: inline-block;
				}

				.icon-certificate {
					margin-right: 10px;
				}

				.icon-arrow {
					color: #304fad;
					font-size: 17px;
					vertical-align: middle;
					float: right;
					height: 22px;
					line-height: 23px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Aside.vue